module.exports = __webpack_public_path__ + "static/media/tick_stroke.accf3396.svg";